import { useTranslation } from 'react-i18next';
import { ActionItemButton } from '@components/button/src/action-button';
import { IconCreateEvent } from '@components/icons';
import { Modal } from '@components/modals';
import { ActionModalType } from '@contexts/modal/modal-context.type';

import { ActionButtonModalProps } from './action-button-modal.type';

export const ActionButtonModal = ({
  open,
  setIsOpen,
  navigateToCreateEvent,
  toggleModal,
  actions,
}: ActionButtonModalProps) => {
  const { t } = useTranslation();
  const handleClickAction = (type: ActionModalType) => {
    toggleModal({ type });
    setIsOpen(false);
  };
  return (
    <Modal
      isOpen={open}
      hasMobileHandle
      handleClose={() => {
        setIsOpen(false);
      }}>
      <div className='flex flex-col w-full pt-4 pb-10 px-4 gap-3 bg-primary'>
        {Object.entries(actions).map(([key, value]) => {
          const Icon = value.icon;
          return (
            <ActionItemButton
              key={key}
              Icon={Icon}
              active={false}
              text={t(`common:actionModal${value.name}Button`)}
              onClick={() => {
                handleClickAction(key as ActionModalType);
              }}
            />
          );
        })}
        {navigateToCreateEvent && (
          <ActionItemButton
            active={false}
            onClick={navigateToCreateEvent}
            text={t('eventList:buttonCreateEvent')}
            Icon={IconCreateEvent}
          />
        )}
      </div>
    </Modal>
  );
};
